import { DEFAULT_PAGINATION } from 'core/constants/pagination.constants';
import { IUsersState } from './types';

export const SLICE_NAMESPACE = 'users';

export const initialState: IUsersState = {
  filters: {},
  userList: {
    data: [],
    isLoading: false,
    pagination: DEFAULT_PAGINATION,
  },
  form: {
    errors: {},
    success: false,
    loading: false,
  },
};
